import React from "react";
import { useProfilePage } from "./hooks/useProfilePage";
import { Box, Divider } from "@mui/material";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import Navbar from "pages/navbar";
import ProfileName from "./components/profileName";
import ProfileOrgDetails from "./components/profileOrgDetails";

function ProfilePage() {
  const { isLargeScreen, user } = useProfilePage();

  return (
    <>
      <Navbar />
      <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
        <WidgetWrapper>
          <FlexBetween>
            <Header title="Profile Page" subtitle="Your profile" />
          </FlexBetween>
          <Divider sx={{ mt: 2, mb: 2 }} />
          <Box
            display={isLargeScreen ? "flex" : "block"}
            justifyContent="space-between"
            gap={2}
          >
            <ProfileName user={user} isLargeScreen={isLargeScreen} />
            <ProfileOrgDetails user={user} isLargeScreen={isLargeScreen} />
            {/* <ProfileImage user={user} handleOpen={handleProfileImageOpen} /> */}
          </Box>
        </WidgetWrapper>
      </Box>
    </>
  );
}

export default ProfilePage;
